import { DARK_RED, MAIN, st } from "../../constants/styles";
//   1: { label: "Pending", class: "bg-secondary" },
//   2: { label: "InventoryReserved", class: "bg-primary" },
//   3: { label: "AwaitingPayment", class: "bg-warning text-dark" },
//   4: { label: "AwaitingConfirmation", class: "bg-warning text-dark" },
//   5: { label: "Paid", class: "bg-success" },
//   6: { label: "Processing", class: "bg-info text-dark" },
//   7: { label: "Shipped", class: "bg-primary" },
//   8: { label: "Delivered", class: "bg-success" },
//   9: { label: "Cancelled", class: "bg-danger" },
//   10: { label: "PaymentFailed", class: "bg-danger" },
export const Badge = {
  main: (t) => <span style={st.badge(MAIN, "#fff3e8")}>{t}</span>,
  green: (t) => <span style={st.badge("#2e7d32", "#e8f5e9")}>{t}</span>,
  blue: (t) => <span style={st.badge("#1565c0", "#e3f2fd")}>{t}</span>,
  red: (t) => <span style={st.badge(DARK_RED, "#ffebee")}>{t}</span>,
};
